import script from "./sort.vue?vue&type=script&setup=true&lang=js"
export * from "./sort.vue?vue&type=script&setup=true&lang=js"

import "./sort.vue?vue&type=style&index=0&id=6652ff32&lang=css"

const __exports__ = script;

export default __exports__